import React from 'react'
import "./init";
import ReactDOM from 'react-dom/client'
import Root from './App.jsx'
import './index.css';

import { Provider } from 'react-redux'
import { store, persistor } from './state/store'
import { PersistGate } from 'redux-persist/integration/react'

import { Route, BrowserRouter as Router, RouterProvider, Routes, createBrowserRouter, createRoutesFromElements } from 'react-router-dom'
import ReactGA from "react-ga4";
import ErrorBoundary from './components/SHARED/error-boundary/error-boundary.component'


// add this to prompt for a refresh
// const updateSW = registerSW({
//     onNeedRefresh() {
//         if (confirm("New content available. Reload?")) {
//             updateSW(true);
//         }
//     },
// });

const router = createBrowserRouter(
[
    {
        path: '*',
        Component: Root
    },
]
// createRoutesFromElements(
//     <Route path='/' element={<App />}></Route>
// ) 
);

// page views are sent manually on route change in App.jsx, so turn off the
// automatic one here. Skip in dev so localhost traffic stays out of reports
if (import.meta.env.PROD) {
    ReactGA.initialize("G-1ED2W62XM7", { gtagOptions: { send_page_view: false } });
}

ReactDOM.createRoot(document.getElementById('root')).render(
    // <React.StrictMode>
        <Provider store={store}>
            <ErrorBoundary>
                <RouterProvider router={router} />
            </ErrorBoundary>
            {/* <Router>
                <PersistGate persistor={persistor}>
                    <App />
                </PersistGate>
            </Router> */}
        </Provider>
    // </React.StrictMode>,
)
